import {IPromise, IHttpResponse} from 'angular';
import {BaseUrlService} from './base-url.service';

export class RubricaService {
  static $inject: string[] = ['BaseUrlService', '$http'];

  private baseUrl: any;

  constructor(
    _baseUrlService: BaseUrlService,
    private $http: ng.IHttpService,
  ) {
    this.baseUrl = _baseUrlService.getBaseUrl();
  }

  insert(rubricaDocument: any): IPromise<IHttpResponse<any>> {
    return this.$http.put(this.baseUrl + '/anagrafica/set/', rubricaDocument);
  }

  update(rubricaDocument: any): IPromise<IHttpResponse<any>> {
    return this.$http.put(`${this.baseUrl}/anagrafica/update`, rubricaDocument);
  }

  getDocuments(filter: any): IPromise<IHttpResponse<any>> {
    return this.$http.get(this.baseUrl + '/anagrafica/get?filter=' + encodeURIComponent(JSON.stringify(filter)));
  }

  validatePiva(piva: any, id: any): IPromise<IHttpResponse<any>> {
    return this.$http.get(this.baseUrl + '/anagrafica/validate/piva/' + piva + '/id/' + id);
  }

  validateCF(cf: any, id: any): IPromise<IHttpResponse<any>> {
    return this.$http.get(this.baseUrl + '/anagrafica/validate/fiscal-code/' + cf + '/id/' + id);
  }

  validatePivaAndCF(piva: any, cf: any, id: any): IPromise<IHttpResponse<any>> {
    return this.$http.get(this.baseUrl + '/anagrafica/validate/' + id + '/piva-codfisc?piva=' + piva + '&fiscalCode=' + cf);
  }

  validateEmail(rubricaDocument: any): IPromise<IHttpResponse<any>> {
    return this.$http.post(this.baseUrl + '/anagrafica/validate/email/', rubricaDocument);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/rubrica.service.ts